<template>
    <v-card flat>
        <v-card-title>
            <Button
                    width="248"
                    depressed
                    v-on:onClick="openCreateUser"
                    class="my-3"
                    content="+ ADD USER"
            />
            <v-spacer></v-spacer>
            <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
            ></v-text-field>
        </v-card-title>
        <v-data-table
                class="custom-table custom-table__header"
                :headers="headers"
                :items="usersData"
                :loading="loading"
                :items-per-page="itemsPerPage"
                :page.sync="page"
                @update:sort-desc="handleSortDesc"
                @update:sort-by="handleSortBy"
                hide-default-footer
        >
            <template v-slot:item.permissions="{ item }">

                    <div v-for="(n, index) in item.permissions"
                         :key="index">
                        <v-icon v-if="n.level === 'write'" small class="mr-1" title="Write level permission" >mdi-pencil</v-icon>
                        <v-icon v-if="n.level === 'unlimited'" small class="mr-1" title="Unlimited level permission" >mdi-all-inclusive</v-icon>
                        <v-icon v-if="n.level === 'read'" small class="mr-1" title="Read level permission" >mdi-book-open</v-icon>
                        <v-icon v-if="n.level === 'zeroed'" small class="mr-1" title="None level permission" >mdi-block-helper</v-icon>
                        {{n.resource.display_name}}
                    </div>

            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon
                        small
                        class="mr-2"
                        @click="openEditItem(item)"
                        title="Edit user"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                        small
                        @click="openDeleteItem(item)"
                        title="Delete user"
                >
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:no-data> NO DATA </template>
        </v-data-table>
        <v-row class="align-center">
            <v-col cols="12" sm="11" >
                <v-pagination
                        v-model="page"
                        :length="pageCount"
                        :total-visible="7"
                        @input="onChangePagination"
                ></v-pagination>
            </v-col>
            <v-col cols="12" sm="1">
                <v-select
                        :value="10"
                        :items="[5, 10, 15, 20]"
                        label="Items per page"
                        @change="handleItemsPerPage"
                        hint="Items per page"
                        persistent-hint
                ></v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" style="font-size: 10px">
                <div><v-icon small class="mr-1" title="Unlimited level permission" >mdi-all-inclusive</v-icon> - Unlimited level permission</div>
                <div><v-icon small class="mr-1" title="Write level permission" >mdi-pencil</v-icon> - Write level permission</div>
                <div><v-icon small class="mr-1" title="Read level permission" >mdi-book-open</v-icon> - Read level permission</div>
                <div><v-icon small class="mr-1" title="None level permission" >mdi-block-helper</v-icon> - None level permission</div>
            </v-col>
        </v-row>
        <v-dialog v-model="dialogCreate" max-width="700px" persistent>
            <v-card>
                <v-form
                        ref="create"
                        v-model="valid"
                        lazy-validation
                >
                    <v-card-title class="headline scan-header">{{ formTitle }}</v-card-title>
                    <v-card-text>
                        <v-container class="py-0">
                            <v-row>
                                <v-col cols="12" class="py-0">
                                    <v-text-field
                                            v-model="newUser.email"
                                            label="Email"
                                            :rules="[emailRules]"
                                            required
                                    ></v-text-field>
                                    <v-autocomplete
                                            v-model="newUser.client"
                                            :items="getClientsSimple"
                                            placeholder="Client"
                                            item-value="id"
                                            item-text="name"
                                            dense
                                            required
                                            label="Client"
                                            :rules="[autocompleteRule]"
                                    ></v-autocomplete>
                                    <div class="d-flex justify-space-around align-center" >
                                        <h3 >Permissions:</h3>
                                        <v-radio-group v-model="permissionMode" row v-if="this.editedIndex === -1">
                                            <v-radio label="Select roles" value="preset" ></v-radio>
                                            <v-radio label="Manual permissions" value="custom" ></v-radio>
                                        </v-radio-group>
                                    </div>
                                    <v-row>
                                        <v-col cols="12" class="py-0 text-center" v-if="!newUser.permissions.length">
                                            <div>No permissions data</div>
                                        </v-col>
                                        <v-col cols="12" class="pt-0" v-if="newUser.permissions.length && permissionMode === 'custom'">
                                            <div>Drag and drop to set priority. Where the last line has the lowest priority.</div>
                                        </v-col>
                                    </v-row>
                                    <v-simple-table v-if="newUser.permissions.length">
                                        <template>
                                            <thead>
                                                <tr>
                                                    <th class="text-left" v-if="permissionMode === 'custom'"></th>
                                                    <th class="text-left">Feature access</th>
                                                    <th class="text-left">Client access</th>
                                                    <th class="text-left">Access level</th>
                                                    <th class="text-left" v-if="permissionMode === 'custom'"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <draggable v-model="newUser.permissions" group="permissions" @start="drag=true" @end="drag=false" @update="onDraggable" style="display: contents">
                                                    <tr v-for="(n, index) in newUser.permissions" :key="index" style="vertical-align: baseline">
                                                        <td v-if="permissionMode === 'custom'" style="cursor: pointer">
                                                            <v-icon> mdi-drag-horizontal-variant </v-icon>
                                                        </td>
                                                        <td v-if="permissionMode === 'custom'" class="px-2">
                                                            <v-autocomplete
                                                                v-model="n.resource"
                                                                :items="getResources"
                                                                placeholder="Resource"
                                                                item-value="id"
                                                                item-text="display_name"
                                                                required
                                                                dense
                                                                name="resource"
                                                                :rules="[autocompleteRule]"
                                                                @change="((event) => handleChangeResource(event, index))"
                                                            ></v-autocomplete>
                                                        </td>
                                                        <td class="px-2" v-if="permissionMode === 'preset'">
                                                            <v-autocomplete
                                                                    v-model="n.role"
                                                                    :items="['System admin', 'Account admin', 'Client admin', 'Analyst']"
                                                                    placeholder="Role"
                                                                    required
                                                                    dense
                                                                    :rules="[autocompleteRule]"
                                                                    @change="((event) => handleChangeRole(event, index))"
                                                            ></v-autocomplete>
                                                        </td>
                                                        <td class="px-2">
                                                            <v-autocomplete
                                                                    :multiple="permissionMode === 'preset' && currentPermissionRole === 'Account admin'"
                                                                    v-model="n.client"
                                                                    :items="clientsList"
                                                                    placeholder="Client"
                                                                    item-value="id"
                                                                    item-text="name"
                                                                    required
                                                                    dense
                                                                    :rules="[autocompleteWithNullRule]"
                                                                    :disabled="currentPermissionRole === 'System admin' || newUser.permissions[index].resource === adminResourceID || newUser.permissions[index].resource === adminDashboardResourceID"
                                                            ></v-autocomplete>
                                                        </td>
                                                        <td class="px-2">
                                                            <v-autocomplete
                                                                    v-model="n.level"
                                                                    :items="[{name: 'Unlimited', value:'unlimited'},{name: 'Write', value: 'write'},{name: 'Read', value: 'read'},{name: 'None', value: 'zeroed'}]"
                                                                    item-value="value"
                                                                    item-text="name"
                                                                    placeholder="Level"
                                                                    required
                                                                    dense
                                                                    :rules="[autocompleteRule]"
                                                                    :disabled="permissionMode === 'preset'"
                                                            ></v-autocomplete>
                                                        </td>
                                                        <td class="px-2" v-if="permissionMode === 'custom'">
                                                            <v-icon
                                                                    v-if="permissionMode === 'custom'"
                                                                    middle
                                                                    title="Remove permission"
                                                                    @click="removePermission(index)"
                                                            >
                                                                mdi-delete
                                                            </v-icon>
                                                        </td>
                                                        <td hidden>
                                                            <v-text-field
                                                                    v-model="n.priority"
                                                                    label="priority"
                                                                    :value="index"
                                                                    required
                                                            ></v-text-field>
                                                        </td>
                                                    </tr>
                                                </draggable>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <v-row>
                                        <v-col cols="12" align="center" class="py-0" v-if="permissionMode ==='custom'">
                                            <v-btn color="primary" text @click="addPermission" >+ Add</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-container class="py-0">
                            <v-row>
                                <v-col cols="12" align="right">
                                    <v-btn color="red darken-1" text @click="closeCreate">Cancel</v-btn>
                                    <v-btn color="green darken-1" text @click="save">Save</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px" persistent>
            <v-card>
                <v-form
                        ref="delete"
                        v-model="deleteValid"
                        lazy-validation
                >
                    <v-card-title class="headline scan-header">Confirm delete user</v-card-title>
                    <v-card-text>
                        <div>Please, enter 'Delete {{userName}}' in the text field to confirm user deletion</div>
                        <v-text-field
                                v-model="confirmDelete"
                                label="Delete user"
                                :rules="[deleteRule]"
                                single-line
                        ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                        <v-btn color="blue darken-1" text @click="deleteWebsite">OK</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
    import draggable from "vuedraggable";
    import Button from "../common/Button";
    import { createNamespacedHelpers } from "vuex";
    const adminDashboardHelper = createNamespacedHelpers("adminDashboard");
    import adminDashboardApi from '../../api/adminDashboard'
    export default {
        components: {draggable,Button},
        name: 'UsersDashboard',
        computed:{
            ...adminDashboardHelper.mapGetters(["getUsersList", "getClientsSimple", "getResources"]),
            formTitle () {
                return this.editedIndex === -1 ? 'CREATE USER' : 'EDIT USER'
            },
        },
        data () {
            return {
                dragging: true,
                search: '',
                headers: [
                    { text: 'Id', align: 'start', value: 'id', sortable: false  },
                    { text: 'Email', value: 'email' },
                    { text: 'Permissions', value: 'permissions', sortable: false },
                    { text: 'Actions', value: 'actions', sortable: false },
                ],
                usersData: [],
                dialogCreate: false,
                dialogDelete: false,
                loading: true,
                page: 1,
                pageCount: 1,
                itemsPerPage: 10,
                totalCount: 1,
                sortDesc: true,
                sort_field: "email",
                newUser: {
                    email: '',
                    client: '',
                    permissions: [
                        {
                            client: '',
                            resource: '',
                            level: '',
                            priority: 0
                        }
                    ],
                },
                clientsList: [],
                userId: '',
                userName: '',
                editedIndex: -1,
                autocompleteRule: v =>{
                    if (v && Object.keys(v).length !== 0) return true;
                    return 'This field is required';
                },
                deleteRule: v =>{
                    if (!(v && Object.keys(v).length !== 0)) {
                        return 'This field is required';
                    } else if(!(v && this.confirmDelete.includes(`Delete ${this.userName}`))){
                        return 'The confirmation message must meet the requirements';
                    } return true;
                },
                autocompleteWithNullRule: v =>{
                    if (v && Object.keys(v).length !== 0 || v === null) return true;
                    return 'This field is required';
                },
                emailRules: v=>{
                    if(!(v && Object.keys(v).length !== 0)) {
                        return 'This field is required'
                    } else if(!(v && /^[\w-\\.+]+@[\w-]+(\.\w{2,5})+$/.test(v))){
                        return 'E-mail must be valid';
                    }
                    return true;
                },
                confirmDelete: '',
                valid: true,
                deleteValid: true,
                permissionMode: 'preset',
                currentPermissionRole: '',
                adminResourceID : '9bf25cb1-cb49-415d-91a1-6521cd3a4360',
                adminDashboardResourceID :'bcfaa35c-89de-4419-bcfd-0a7bda9597c9',
            }
        },
        methods: {
            ...adminDashboardHelper.mapActions([ "fetchUsersList", "fetchClientsSimple", "fetchResources"]),
            async getClientsSimpleData(){
                await this.fetchClientsSimple();
            },
            getResourcesData(){
                this.fetchResources();
            },
            async getUsersDashboard(){
                this.loading = true;
                await this.fetchUsersList({
                    page: this.page,
                    page_size: this.itemsPerPage < 0 ? this.pageCount : this.itemsPerPage,
                    sort: this.sortDesc ? 1 : 0,
                    s: this.search,
                    sort_field: this.sort_field ? this.sort_field : 'email'
                });
                this.loading = false;
            },
            openCreateUser(){
                this.editedIndex = -1;
                this.permissionMode = 'preset';
                this.dialogCreate = true;
            },
            closeCreate () {
                this.dialogCreate = false;
                this.newUser = {
                    email: '',
                    client: '',
                    permissions: [
                        {
                            client: '',
                            resource: '',
                            level: '',
                            priority: 0
                        }
                    ],
                };
                this.$refs.create.resetValidation();
            },
            async save(){
                if(this.$refs.create.validate()){
                    if(this.editedIndex > -1){
                        try{
                            await adminDashboardApi.editUser(this.userId,
                                Object.assign({},
                                    {email: this.newUser.email},
                                    {client: this.newUser.client === '' ? null : this.newUser.client},
                                    {permissions: this.newUser.permissions})
                            );
                            this.closeCreate();
                            this.getUsersDashboard();
                        }catch(err){
                            alert(err.response ? err.response.data: err);
                        }
                    } else {
                        let userPermissions = [];
                        if(this.currentPermissionRole === 'Account admin'){
                            this.newUser.permissions[0].client.forEach(c=>{
                                userPermissions.push({client: c, resource: "3386bb9f-8f2e-4050-90a6-74bec932962a", level: "unlimited", priority: 1})
                            });
                        }
                        if(this.currentPermissionRole === 'System admin'){
                            this.newUser.permissions.forEach(p=>{
                                userPermissions.push(p);
                            });
                            userPermissions.push({client: null, resource: "bcfaa35c-89de-4419-bcfd-0a7bda9597c9", level: "write", priority: 100})
                        }
                        try{
                            await adminDashboardApi.createUser(
                                this.currentPermissionRole === 'Account admin' || this.currentPermissionRole === 'System admin'  ?
                                Object.assign({},
                                    {email: this.newUser.email},
                                    {client: this.newUser.client === '' ? null : this.newUser.client},
                                    {permissions: userPermissions},
                                ) : Object.assign({},
                                        {email: this.newUser.email},
                                        {client: this.newUser.client === '' ? null : this.newUser.client},
                                        {permissions: this.newUser.permissions},
                                    )
                            );
                            this.closeCreate();
                            this.getUsersDashboard();
                        }catch(err){
                            alert(err.response ? err.response.data: err);
                        }
                    }
                }

            },
            openDeleteItem(user){
                this.userId = user.id;
                this.userName = user.email;
                this.dialogDelete = true
            },
            closeDelete(){
                this.dialogDelete = false;
                this.confirmDelete = '';
                this.$refs.delete.resetValidation();
            },
            async deleteWebsite(){
                if(this.$refs.delete.validate()){
                    if(this.confirmDelete.includes(`Delete ${this.userName}`)){
                        try{
                            await adminDashboardApi.deleteUser(this.userId);
                            this.closeDelete();
                            this.getUsersDashboard();
                        }catch(err){
                            alert(err)
                        }
                    }
                }
            },
            openEditItem(user){
                this.permissionMode = 'custom';
                this.userId = user.id;
                this.editedIndex = this.usersData.indexOf(user);
                let permissions =[];
                user.permissions.forEach(p=>{
                    let pItem = { client: p.client === null ? p.client : p.client.id, resource: p.resource === null ? p.resource : p.resource.id, level: p.level, priority: p.priority };
                    permissions.push(pItem)
                });
                this.newUser = Object.assign({},
                    {email: user.email},
                    {client: user.client === null ? '' : user.client.id},
                    {permissions: permissions},
                );
                this.dialogCreate = true;
            },
            handleItemsPerPage(itemsPerPage){
                this.page = 1;
                this.itemsPerPage = itemsPerPage;
                this.getUsersDashboard();
            },
            handleSortDesc(desc){
                if( this.sortDesc !== desc[0] && desc.length){
                    this.sortDesc = desc[0];
                    this.getUsersDashboard();
                }
            },
            handleSortBy(sortBy){
                if(this.sort_field !== sortBy[0] && sortBy.length){
                    this.sort_field = sortBy[0];
                    this.getUsersDashboard();
                }
            },
            addPermission(){
                this.newUser.permissions.unshift({client: '', resource: '', level: '', priority: this.newUser.permissions.length});
            },
            removePermission(index){
                this.newUser.permissions.splice(index, 1)
            },
            handleChangeRole(e){
                this.currentPermissionRole = e;
                if(e === 'System admin'){
                    this.clientsList.unshift({id: null, name: "All"});
                    this.newUser.permissions = [{client: null, resource: "3386bb9f-8f2e-4050-90a6-74bec932962a", level: 'unlimited', priority: 1}];
                }else if(e === 'Account admin'){
                    this.removeAllClients();
                    this.newUser.permissions = [{client: '', resource: "3386bb9f-8f2e-4050-90a6-74bec932962a", level: "unlimited", priority: 0}];
                }else if(e === 'Client admin'){
                    this.removeAllClients();
                    this.newUser.permissions = [{client: '',resource: "3386bb9f-8f2e-4050-90a6-74bec932962a",level: "write", priority: 0}];
                }else if(e === 'Analyst'){
                    this.removeAllClients();
                    this.newUser.permissions = [{client: '',resource: "3386bb9f-8f2e-4050-90a6-74bec932962a",level: "read",priority: 0}];
                }
            },
            onDraggable(){
                let permissionsLength = this.newUser.permissions.length - 1;
                this.newUser.permissions.forEach((p, index)=>{
                    let i = permissionsLength - index;
                    this.newUser.permissions[index].priority = i;
                });
            },
            onChangePagination(){
                this.getUsersDashboard();
            },
            removeAllClients(){
                this.clientsList.forEach((c,i)=>{
                    if(c.id === null){
                        this.clientsList.splice(i, 1)
                    }
                });
            },
            handleChangeResource(resourceId, index){
                if(resourceId === this.adminResourceID || resourceId === this.adminDashboardResourceID){
                    this.newUser.permissions[index].client = null
                }
            }
        },
        created () {
            this.getUsersDashboard();
            this.getClientsSimpleData();
            this.getResourcesData();
        },
        watch: {
            getUsersList: function(e){
                this.usersData = e.results;
                this.pageCount = Math.ceil(e.count/this.itemsPerPage);
                this.totalCount = e.count;
            },
            search: function(){
                this.page = 1;
                this.getUsersDashboard();
            },
            getClientsSimple: function(clients){
                clients.forEach(c=>{
                    this.clientsList.push(c)
                })
            },
            permissionMode: function(mode){
                this.currentPermissionRole = '';
                mode === 'custom' ? this.clientsList.unshift({id: null, name: "All"}) : this.removeAllClients();
                if(this.editedIndex === -1) {
                    this.newUser.permissions = [{client: '',resource: '', level: '', priority: 0 }];
                }
                if(this.$refs.create){
                    this.$refs.create.resetValidation();
                }
            }
        }
    }
</script>
